<ng-container *ngIf="!ready">
  <ion-spinner></ion-spinner>
</ng-container>

<ng-container *ngIf="config && model && ready">
  <!-- <div class="person-avatar" *ngIf="config.modelAlias == 'person'">
    <ion-avatar>
      <img src="{{fallbackImages.getAvatar(model.avatar?.url)}}">
    </ion-avatar>
    <ion-fab-button class="upload-avatar" (click)="uploadAvatar()">
      <ion-icon name="create"></ion-icon>
    </ion-fab-button>
  </div> -->

  <ion-list>
    <ng-container *ngFor="let field of config.readFields">

      <ion-item *ngIf="field.type == 'text'">
        <ion-label position="stacked">{{field.label}}</ion-label>
        <ion-note>
          {{model[field.name]}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'person'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note *ngIf="model[field.name] && (states.getFromStoreOrFromApi('person', model[field.name]) | async) as person">
            {{
              format.formatPersonName(
                      (person)
              )
            }}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'string'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end" *ngIf="model[field.name] == 'MALE'">
          {{gender[0]}}
        </ion-note>

        <ion-note slot="end" *ngIf="model[field.name] == 'FEMALE'">
          {{gender[1]}}
        </ion-note>

        <ion-note slot="end" *ngIf="field.label != 'Geslacht'">
          {{model[field.name]}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'relation_config'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end" *ngIf="model && model[field.name]">
          {{model[field.name]['name']}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'number'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          {{format.formatNumber(model[field.name])}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'money'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          {{format.formatEuroInWords(model[field.name])}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'function'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          {{field['data']['from'](model)}}
        </ion-note>
      </ion-item>

      <ion-item  *ngIf="field.type == 'date'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          {{this.format.formatDate( model[field.name] )}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'boolean'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          {{this.format.formatBoolean( model[field.name] )}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'nationality'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end" *ngIf="model['nationality']">
          {{model['nationality']['name']}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'address'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          {{format.formatAddress(model['address'])}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'relation'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end" *ngIf="model['relation']">
          {{model['relation']['name']}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'vehicle_type'">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          {{model['type']['name']}}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'construction'">
        <ion-label>{{ field.label }}</ion-label>
        <ion-note slot="end">
          {{ model['construction_type']['name'] }}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'home_type'">
        <ion-label>{{ field.label }}</ion-label>
        <ion-note slot="end">
          {{ model['home_type']['name'] }}
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'm2'">
        <ion-label>{{ field.label }}</ion-label>
        <ion-note slot="end">
          {{ format.formatNumber(model[field.name]) }} &#13217;
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == 'm3'">
        <ion-label>{{field.label }}</ion-label>
        <ion-note slot="end">
          {{ format.formatNumber(model[field.name]) }} &#13221;
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == FieldConfig.TYPE_FINANCIAL_COMPANIES">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          <ng-container *ngIf="(states.getFromStoreOrFromApi('financial_company', model[field.name]) | async) as data">
            {{ data.name }}
          </ng-container>
        </ion-note>
      </ion-item>

      <ion-item *ngIf="field.type == FieldConfig.TYPE_HOMES">
        <ion-label>{{field.label}}</ion-label>
        <ion-note slot="end">
          <ng-container *ngIf="(states.getFromStoreOrFromApi('home', model[field.name]) | async) as data">
            {{ data.address.city }}, {{ data.address.country.name }}
          </ng-container>
        </ion-note>
      </ion-item>

    </ng-container>

  </ion-list>

</ng-container>
